import { useQuery } from 'react-query';
import { network } from 'services/network';

const getFinishDateChangesTableData = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network
        .post('api/bo/getTopFinishDateChanges', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryFinishDateChangesTableData = (params) => {
    return useQuery(['finishDateChangesTableData', params], () => getFinishDateChangesTableData(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
